export default __webpack_public_path__ + "static/media/icon-wrench.146e62c2.svg";